module.exports = __webpack_public_path__ + "img/t5-19.de7e41aa.svg";